import { HeaderInfo } from '@api/core';
import { patchState, signalStoreFeature, withMethods, withState } from '@ngrx/signals';

export const useInfo = () =>
  signalStoreFeature(
    withState({
      pendingTransfers: 0,
      pendingSettlements: 0,
      pendingFireblocksSettlements: 0,
    }),
    withMethods(store => {
      const updateInfo = (info: HeaderInfo) => {
        patchState(store, info);
      };

      return { updateInfo };
    }),
  );
